import { render } from "./EmployeeApprovalsNew.vue?vue&type=template&id=605ab5de&scoped=true"
import script from "./EmployeeApprovalsNew.vue?vue&type=script&lang=js"
export * from "./EmployeeApprovalsNew.vue?vue&type=script&lang=js"

import "./EmployeeApprovalsNew.vue?vue&type=style&index=0&id=605ab5de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605ab5de"]])

export default __exports__